import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import { isTextualDeviation } from '../../../DeviationViews/_helpers';
import AdoptableSeller from '../../buttons/AdoptableSeller';
import AdoptableBuyer from '../../buttons/AdoptableBuyer';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import CentralColumn from '../../../DeviationPage/_partials/CentralColumn';
import DeviationFlags from '../../buttons/DeviationFlags';
import { PremiumDownloadButton } from '../../buttons/DownloadButton';
import SellYourArtLink from '../../buttons/SellYourArtLink';
import { StashElementPlacementContext } from '../../ElementPlacementContext/variants/stash/context';
import { useElementPlacementForArea } from '../../ElementPlacementContext';
import { StashDeviationElementPlacement } from '../../ElementPlacementContext/variants/stash/types';
import EditButton from './EditButton';
import CopyLinkButton from './CopyLinkButton';
import MoreButton from './MoreButton';
import FreeDownloadButton from './DownloadButton';
import s from './StashActionBar.scss';
const StashActionBar = ({ deviation, isOwner, className })=>{
    const placementMap = useElementPlacementForArea(StashDeviationElementPlacement.PrimaryBar, StashElementPlacementContext);
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const { hasFlag } = useDeviationAttributes(deviation, isOwner);
    const isTextual = isTextualDeviation(deviation);
    return /*#__PURE__*/ React.createElement(ActionBarStrip, {
        className: cn(s['root'], className)
    }, /*#__PURE__*/ React.createElement(CentralColumn, null, isMobile ? /*#__PURE__*/ React.createElement("div", {
        className: s['mobile-content-root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['mobile-visibility-and-more-actions-row']
    }, isOwner && /*#__PURE__*/ React.createElement("span", {
        className: s['visibility-disclosure']
    }, t('stashBanner.message', {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        prefix: /*#__PURE__*/ React.createElement("span", {
            className: s['prefix-message']
        }, t('stashBanner.message.prefix'))
    })), placementMap.meta.hasPrimaryMoreActionsMenu && /*#__PURE__*/ React.createElement("div", {
        className: s['mobile-more-button-container']
    }, /*#__PURE__*/ React.createElement(MoreButton, {
        deviation: deviation,
        className: s['mobile-more-button']
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['mobile-copy-download-edit-row']
    }, placementMap.sellDeviation && /*#__PURE__*/ React.createElement(SellYourArtLink, {
        deviation: deviation
    }), placementMap.copyLink && /*#__PURE__*/ React.createElement(CopyLinkButton, {
        deviation: deviation
    }), placementMap.freeDownload && /*#__PURE__*/ React.createElement(FreeDownloadButton, {
        deviation: deviation
    }), placementMap.editDeviation && /*#__PURE__*/ React.createElement(EditButton, {
        deviation: deviation
    }))) : /*#__PURE__*/ React.createElement("div", {
        className: s['desktop-content-root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left-side']
    }, hasFlag && /*#__PURE__*/ React.createElement(DeviationFlags, {
        deviation: deviation,
        disableLabel: isTextual
    }), placementMap.elementGroups.adoptableSeller.groupPlacement && /*#__PURE__*/ React.createElement(AdoptableSeller, {
        deviation: deviation,
        manualElementGroup: placementMap.elementGroups.adoptableSeller
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['right-side']
    }, placementMap.elementGroups.adoptableBuyer.groupPlacement && /*#__PURE__*/ React.createElement(AdoptableBuyer, {
        deviation: deviation,
        manualElementGroup: placementMap.elementGroups.adoptableBuyer
    }), placementMap.sellDeviation && /*#__PURE__*/ React.createElement(SellYourArtLink, {
        deviation: deviation
    }), placementMap.copyLink && /*#__PURE__*/ React.createElement(CopyLinkButton, {
        deviation: deviation
    }), placementMap.editDeviation && /*#__PURE__*/ React.createElement(EditButton, {
        deviation: deviation
    }), placementMap.freeDownload && /*#__PURE__*/ React.createElement(FreeDownloadButton, {
        deviation: deviation
    }), placementMap.premiumDownload && /*#__PURE__*/ React.createElement(PremiumDownloadButton, {
        deviation: deviation
    }), placementMap.meta.hasPrimaryMoreActionsMenu && /*#__PURE__*/ React.createElement(MoreButton, {
        deviation: deviation
    })))));
};
StashActionBar.displayName = 'StashActionBar';
export default StashActionBar;

//# sourceMappingURL=StashActionBar.private_sell.js.map